export enum Method {
  GET = 'GET',
  POST = 'POST',
}
